import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Link,
} from "@mui/material";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  StyleAlert,
  StyleButton,
  StyleButtonLarge,
  StyleHeading,
  StyleInputLabel,
  StyleTextField,
  StyleTooltipMessage,
  // StyleTypography,
} from "../../assets/js/Theme";
import {
  CONFIDENCE_BAND_LOW,
  CONFIDENCE_NOT_AVAILABLE,
  MOCK_PDF_URL,
  T_AND_C_URL,
  QUERY_PARAM_FRAME_SRC,
  QUERY_PARAM_FRAME_SRC_VALUE,
} from "../../resources/Constants";
import { Formik } from "formik";
import {
  IsNotValidEmail,
  sendPageView,
  _trackActivity,
} from "../../resources/utils";
import OtpVerification from "./OtpVerification";
import {
  generateOtp,
  verifyConsumerOtp,
  verifyUser,
} from "../../crud/avm.crud";
import MockImg from "../../assets/images/mock-pdf-image.png";
import PdfIcon from "../../assets/images/pdf-icon.png";
import PaymentFrame from "./PaymentFrame";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useLocation } from "react-router-dom";
import { Recaptcha } from "./Recaptcha";
import { useServices } from "../../services/hooks";

const AvmPreCheck = (props) => {
  const {
    intl,
    preAvmData,
    runAvm,
    currentUser,
    goBack,
    reportHash,
    currentSession,
    setContext,
  } = props;
  const { eventBusService } = useServices();
  const [showOtp, setShowOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [generateOtpLoading, setGenerateOtpLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState("");
  const [formValues, setFormValues] = useState({
    name: currentUser.name,
    email: currentUser.email,
    phone: currentUser.phone,
  });
  const [termsSelected, setTermsSelected] = useState(false);
  const [showPaymentFrame, setShowPaymentFrame] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const amountToPayForCampaigns = 149;
  const amountToPay = preAvmData?.amountToPay || amountToPayForCampaigns;
  const verifiedUser = currentUser?.verified;
  const isVerifiedUser = verifiedUser ? true : false;
  const isCampaignActive = currentUser?.is_campaign_active;
  const isFree = isCampaignActive ? true : false;
  const isRecaptchaEnabled =
    eventBusService.getMessageByChannel("pmv3")?.reCAPTCHAEnabled ?? true;
  const externalLink = (url) => {
    window.open(url, "_blank");
  };
  useEffect(() => {
    sendPageView("/pre-check-avm");
    setContext("pre-check-avm");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isVerifiedUser) {
      setTermsSelected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerifiedUser]);

  const _verifyOtp = async (otpCode) => {
    try {
      if (otpCode) {
        const postParams = {
          email: formValues.email,
          phone: formValues.phone,
          otpCode,
          reportHash,
        };
        setLoading(true);
        const result = await verifyConsumerOtp(postParams);
        const { status, data } = result.data;
        setLoading(false);
        if (status === 1) {
          if (data.verified) {
            currentUser.verified = 1;
            currentUser.userConsumerId = data.user_consumer_id;
            _closeOtpModal();
            runAvm(reportHash);
          }
        } else {
          setShowError(true);
          result.data.errors && alert(result.data.errors);
        }
      } else {
        alert("Enter valid otp");
      }
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
    }
  };
  const _generateOtp = async (values) => {
    const postParams = values || formValues;
    postParams.reportHash = reportHash;
    setGenerateOtpLoading(true);
    const result = await generateOtp(postParams);
    const { status } = result.data;
    setGenerateOtpLoading(false);
    if (status === 1) {
      _showOtpModal();
    } else {
      setGenerateOtpLoading(false);
      result.data.errors && alert(result.data.errors);
    }
  };

  const _showPaymentFrame = async () => {
    setPaymentInfo("");
    setShowPaymentFrame(true);
    const trackParams = {
      event: "button-click",
      action: "payment",
      status: "clicked-on-pay-button",
      context: "pre-check-avm",
      userId: currentUser?.user_id || "",
      userConsumerId: currentUser?.userConsumerId || "",
      currentSession,
    };
    _trackActivity(trackParams);
  };
  const _closePaymentFrame = async () => {
    setShowPaymentFrame(false);
  };
  const _doProcess = async (values, setSubmitting) => {
    try {
      if (preAvmData?.confidenceLevel === CONFIDENCE_NOT_AVAILABLE) {
        const trackParams = {
          event: "button-click",
          action: "back",
          status: "AVM not available and sent user details",
          context: "pre-check-avm",
          userId: currentUser?.user_id || "",
          userConsumerId: currentUser?.userConsumerId || "",
          currentSession,
        };
        //No avm available
        _trackActivity(trackParams);
        goBack();
        return;
      }
      currentUser.name = values?.name || "";
      currentUser.email = values?.email || "";
      currentUser.phone = values?.phone || "";
      setFormValues(values);
      if (isCampaignActive) {
        //Otp Verification need
        setLoading(true);
        setSubmitting(false);
        const postParams = {
          email: values?.email || "",
          phone: values?.phone || "",
          reportHash: reportHash || "",
        };
        const result = await verifyUser(postParams);
        setLoading(false);
        setSubmitting(false);
        const { status, data } = result.data;
        if (status === 1) {
          const isVerified = data.verified;
          if (isVerified) {
            currentUser.verified = 1;
            currentUser.userConsumerId = data.user_consumer_id;
            // _showPaymentFrame()
            runAvm(reportHash);
          } else {
            const params = {
              name: values?.name || "",
              email: values?.email || "",
              phone: values?.phone || "",
            };
            _generateOtp(params);
          }
        } else {
          result.data.error && alert(result.data.error);
          console.log("data are not populated");
        }
      } else {
        _showPaymentFrame();
      }
    } catch (error) {
      setLoading(false);
      setSubmitting(false);
      console.log("error", error);
    }
  };

  const _showOtpModal = () => {
    setShowOtp(true);
  };
  const _closeOtpModal = () => {
    setShowOtp(false);
    setShowError(false);
  };
  const _doPostPaymentProcess = (params) => {
    const trackParams = {
      event: "button-click",
      action: "payment",
      status: params?.message,
      context: "pre-check-avm",
      userId: currentUser?.user_id || "",
      userConsumerId: currentUser?.userConsumerId || "",
      currentSession,
    };
    if (params?.status === "success") {
      runAvm(reportHash);
    } else {
      _closePaymentFrame();
      setPaymentInfo(params);
    }
    _trackActivity(trackParams);
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} className="avm--result--header">
          <StyleButton
            variant="outlined"
            size="large"
            onClick={() => {
              const trackParams = {
                event: "button-click",
                action: "back",
                status: "success",
                context: "pre-check-avm",
                currentSession,
                userId: currentUser?.user_id || "",
                userConsumerId: currentUser?.userConsumerId || "",
              };
              _trackActivity(trackParams);
              goBack(trackParams);
            }}
          >
            {intl.formatMessage({ id: "GENERAL.BACK" })}
          </StyleButton>
        </Grid>
      </Grid>
      <Grid container className="pre--check--wrapper">
        <Grid item xs={12}>
          {
            <StyleAlert
              variant="filled"
              severity={`${
                preAvmData.confidenceLevel &&
                preAvmData.confidenceLevel !== CONFIDENCE_NOT_AVAILABLE
                  ? preAvmData.confidenceLevel === CONFIDENCE_BAND_LOW
                    ? "warning"
                    : "success"
                  : "error"
              }`}
            >
              {preAvmData.confidenceMessage}
            </StyleAlert>
          }
        </Grid>
      </Grid>
      {preAvmData.confidenceLevel !== CONFIDENCE_NOT_AVAILABLE ? (
        <Grid container className="user--information--wrapper">
          <Grid item xs={12} className="pricing--wrapper bold-price-wrapper">
            <div className="total-price-details">
              <Typography variant="h6" className="font-weight-300">
                {intl.formatMessage({ id: "AVM.PRE.CHECK.THE_COST_AVM" })}
              </Typography>
              <>
                <StyleHeading
                  component="span"
                  className={`${
                    isFree ? "strike--through" : null
                  } font-weight-400`}
                  variant="h1"
                >
                  {`${intl.formatMessage({ id: "GENERAL.AED" })} ${
                    isFree ? amountToPayForCampaigns : amountToPay
                  } `}
                </StyleHeading>
                {isFree ? (
                  <>
                    <StyleHeading
                      component="span"
                      variant="h1"
                      className="font-weight-400"
                    >
                      {` ${intl.formatMessage({
                        id: "AVM.PRE.CHECK.FREE",
                      })}`}
                    </StyleHeading>
                    <Typography
                      component="span"
                      variant="h6"
                      className="font-weight-300"
                    >
                      {` ${intl.formatMessage({
                        id: "AVM.PRE.CHECK.FOR_LIMITED_TIME",
                      })}`}
                    </Typography>
                  </>
                ) : (
                  <StyleHeading
                    component="span"
                    className={"font-weight-300"}
                    variant="h6"
                  >
                    {" "}
                    <FormattedMessage id="AVM.GENERAL.INCLUSIVE_VAT" />
                  </StyleHeading>
                )}
              </>
            </div>
            <hr />
          </Grid>

          <Grid item xs={12}>
            {showPaymentFrame ? (
              <PaymentFrame
                reportHash={reportHash}
                currentUser={currentUser}
                doPostPaymentProcess={_doPostPaymentProcess}
              />
            ) : null}
          </Grid>
          {paymentInfo ? (
            <Grid item xs={12}>
              <StyleAlert variant="filled" severity={`${paymentInfo?.status}`}>
                {paymentInfo?.status === "success"
                  ? paymentInfo?.message
                  : intl.formatMessage(
                      {
                        id: "GENERAL.PAYMENT_ERROR",
                      },
                      { reason: paymentInfo?.message, break: <br /> }
                    )}
              </StyleAlert>
            </Grid>
          ) : null}

          {!showPaymentFrame ? (
            <Formik
              initialValues={formValues}
              validate={(values) => {
                const errors = {};
                if (
                  preAvmData?.confidenceLevel !== CONFIDENCE_NOT_AVAILABLE &&
                  !values.email
                ) {
                  errors.email = intl.formatMessage({
                    id: "VALIDATION.REQUIRED_FIELD",
                  });
                }
                if (!values.phone) {
                  errors.phone = intl.formatMessage({
                    id: "VALIDATION.REQUIRED_FIELD",
                  });
                }
                if (!values.name) {
                  errors.name = intl.formatMessage({
                    id: "VALIDATION.REQUIRED_FIELD",
                  });
                }
                if (values.email && IsNotValidEmail(values.email)) {
                  errors.email = intl.formatMessage({
                    id: "VALIDATION.EMAIL_NOT_VALID",
                  });
                }
                if (values.phone && !isValidPhoneNumber(values.phone)) {
                  // values.phone ? (isValidPhoneNumber(values.phone) ? undefined : 'Invalid phone number') : 'Phone number required'
                  errors.phone = intl.formatMessage({
                    id: "VALIDATION.PHONE_NOT_VALID",
                  });
                }
                if (!values.recaptcha && isRecaptchaEnabled) {
                  errors.recaptcha = intl.formatMessage({
                    id: "VALIDATION.REQUIRED_FIELD",
                  });
                }

                if (!termsSelected) {
                  errors.terms = intl.formatMessage({
                    id: "VALIDATION.REQUIRED_FIELD",
                  });
                }

                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                _doProcess(values, setSubmitting);
              }}
            >
              {({
                values,
                handleChange,
                handleSubmit,
                errors,
                touched,
                isSubmitting,
                setFieldValue,
              }) => (
                <form
                  noValidate={true}
                  autoComplete="off"
                  className="kt-form user-detail-form"
                  onSubmit={handleSubmit}
                >
                  <>
                    <Grid item xs={12}>
                      <StyleHeading color="primary" variant="h3">
                        {intl.formatMessage({
                          id: "AVM.PRE.CHECK.PLEASE_ENTER_INFORMATION",
                        })}
                      </StyleHeading>
                    </Grid>
                    <div className="user-form-groups">
                      <div className="user-form">
                        <div className="form-wrapper">
                          <Grid item xs={12} className="form-group">
                            <StyleInputLabel
                              htmlFor="bootstrap-input"
                              color="primary"
                            >
                              {intl.formatMessage(
                                {
                                  id: "GENERAL.NAME",
                                },
                                {
                                  required: (
                                    <Typography
                                      color="error"
                                      component="span"
                                      variant="body1"
                                    >
                                      *
                                    </Typography>
                                  ),
                                }
                              )}
                            </StyleInputLabel>
                            <StyleTextField
                              id="name"
                              name="name"
                              // disabled={isVerifiedUser}
                              placeholder={intl.formatMessage({
                                id: "GENERAL.PLACEHOLDER.ENTER_NAME",
                              })}
                              variant="outlined"
                              value={values.name}
                              onChange={(event) => {
                                handleChange(event);
                              }}
                              helperText={touched.name && errors.name}
                              error={Boolean(touched.name && errors.name)}
                            />
                          </Grid>
                          <Grid item xs={12} className="form-group">
                            <StyleInputLabel
                              htmlFor="bootstrap-input"
                              color="primary"
                            >
                              {intl.formatMessage(
                                {
                                  id: "GENERAL.EMAIL",
                                },
                                {
                                  required: (
                                    <Typography
                                      color="error"
                                      component="span"
                                      variant="body1"
                                    >
                                      *
                                    </Typography>
                                  ),
                                }
                              )}
                            </StyleInputLabel>
                            <StyleTextField
                              id="email"
                              name="email"
                              // disabled={isVerifiedUser}
                              variant="outlined"
                              placeholder={intl.formatMessage({
                                id: "GENERAL.PLACEHOLDER.ENTER_EMAIL",
                              })}
                              value={values.email}
                              onChange={(event) => {
                                handleChange(event);
                              }}
                              helperText={touched.email && errors.email}
                              error={Boolean(touched.email && errors.email)}
                            />
                          </Grid>
                          <Grid item xs={12} className="form-group">
                            <StyleInputLabel
                              htmlFor="bootstrap-input"
                              color="primary"
                            >
                              {intl.formatMessage(
                                {
                                  id: "GENERAL.PHONE",
                                },
                                {
                                  required: (
                                    <Typography
                                      color="error"
                                      component="span"
                                      variant="body1"
                                    >
                                      *
                                    </Typography>
                                  ),
                                }
                              )}
                            </StyleInputLabel>
                            <PhoneInput
                              id="phone"
                              name="phone"
                              defaultCountry="AE"
                              international
                              // withCountryCallingCode
                              className="country-code-field"
                              placeholder="971 54 123 4567"
                              value={values.phone}
                              onChange={(value) => {
                                setFieldValue("phone", value || "");
                              }}
                            />
                            {touched.phone ? (
                              values.phone ? (
                                isValidPhoneNumber(values.phone) ? undefined : (
                                  <span className="error-msg">
                                    Invalid phone number
                                  </span>
                                )
                              ) : (
                                <span className="error-msg">
                                  Phone number required
                                </span>
                              )
                            ) : null}
                          </Grid>
                          {isRecaptchaEnabled ? (
                            <Grid item xs={12} className="form-group">
                              <Recaptcha
                                onSubmitRecaptchaHandler={(value) =>
                                  setFieldValue("recaptcha", value)
                                }
                              />
                              {Boolean(errors.recaptcha) && (
                                <span className="error-msg">
                                  To proceed, please click on the reCAPTCHA
                                  checkbox
                                </span>
                              )}
                            </Grid>
                          ) : null}
                          <Grid
                            item
                            xs={12}
                            className="form-group checkbox-wrapper"
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={termsSelected}
                                  onChange={(event) => {
                                    setTermsSelected(event.target.checked);
                                  }}
                                  name="terms"
                                  color="primary"
                                />
                              }
                              label={intl.formatMessage(
                                { id: "ACCEPT_TERMS" },
                                {
                                  terms: (
                                    <Link
                                      onClick={() => externalLink(T_AND_C_URL)}
                                      className="pdf-mock-link tooltip--icon"
                                    >
                                      <Typography
                                        color="secondary"
                                        component="span"
                                      >
                                        {intl.formatMessage({
                                          id: "ACCEPT_TERMS_LINK",
                                        })}
                                      </Typography>
                                    </Link>
                                  ),
                                }
                              )}
                            />
                            <FormHelperText color="warning">
                              <Typography
                                color="error"
                                variant="caption"
                                className="terms-error-message"
                              >
                                {!termsSelected && errors.terms}
                              </Typography>
                            </FormHelperText>
                          </Grid>
                        </div>
                        <Grid item xs={12}>
                          <Grid
                            container
                            spacing={3}
                            className="button--wrapper"
                            justifyContent="flex-end"
                          >
                            <Grid item xs={12} md={6}>
                              <StyleButtonLarge
                                disabled={
                                  isSubmitting ||
                                  loading ||
                                  showPaymentFrame ||
                                  generateOtpLoading
                                }
                                type="submit"
                                variant="contained"
                                fullWidth
                                color="secondary"
                                size="large"
                                className="btn--wrapper"
                              >
                                {isCampaignActive ? (
                                  <FormattedMessage id="GENERAL.SHOW_AVM" />
                                ) : (
                                  <FormattedMessage id="GENERAL.PAY_NOW" />
                                )}

                                {(generateOtpLoading || loading) && (
                                  <CircularProgress color="primary" size={24} />
                                )}
                              </StyleButtonLarge>
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                      {(!params.has(QUERY_PARAM_FRAME_SRC) ||
                        params.get(QUERY_PARAM_FRAME_SRC) !==
                          QUERY_PARAM_FRAME_SRC_VALUE) && (
                        <div className="mock-wrapper">
                          <div className="mock-wrapper-inner">
                            <p>Click below to view a sample report</p>
                            <StyleTooltipMessage
                              title={
                                <>
                                  <Typography>Sample Report</Typography>
                                </>
                              }
                              arrow
                              placement="bottom"
                            >
                              <Link
                                onClick={() => {
                                  externalLink(MOCK_PDF_URL);
                                  const trackParams = {
                                    event: "button-click",
                                    action: "sample-report",
                                    status: "Sample report click detected",
                                    context: "pre-check-avm",
                                    userId: currentUser?.user_id || "",
                                    userConsumerId:
                                      currentUser?.userConsumerId || "",
                                    currentSession,
                                  };
                                  _trackActivity(trackParams);
                                }}
                                className="pdf-mock-link tooltip--icon"
                              >
                                <img alt="preview" src={MockImg} />
                                <em className="pdf-icon">
                                  <img alt="preview" src={PdfIcon} />
                                </em>
                              </Link>
                            </StyleTooltipMessage>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                </form>
              )}
            </Formik>
          ) : null}
        </Grid>
      ) : preAvmData.confidenceLevel === CONFIDENCE_NOT_AVAILABLE ? (
        <StyleButtonLarge
          onClick={() => goBack()}
          variant="contained"
          color="secondary"
          size="large"
          className="btn--wrapper newavm-btn"
        >
          {intl.formatMessage({
            id: "GENERAL.NEW_AVM",
          })}
        </StyleButtonLarge>
      ) : null}
      <OtpVerification
        showOtp={showOtp}
        closeOtpModal={_closeOtpModal}
        generateOtp={_generateOtp}
        verifyOtp={_verifyOtp}
        showError={showError}
        generateOtpLoading={generateOtpLoading}
      />
    </>
  );
};

export default injectIntl(AvmPreCheck);
